// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactBanner_wrapper__doGap","title":"ContactBanner_title__qhZFx","description":"ContactBanner_description__KJ5bj"};